<header class="org-header">

  <div class="header-right">
    <!-- as this is static
 <div class="icon-wrapper" (click)="toggleDropdown('notification', $event)">
      <i class="material-icons">notifications_none</i>
      <span class="badge">4</span>

      <div class="dropdown notifications" *ngIf="showNotification">
        <div class="dropdown-header">
          <div class="left">
            <h4>Notifications</h4>
            <span class="new-badge">4 new</span>
          </div>
          <button class="mark-all">Mark all read</button>
        </div>

        <div class="notification-list">
          <div class="notification-item" *ngFor="let n of notifications">
            <div class="icon" [ngStyle]="{ background: n.bg }">
              <i class="material-icons" [style.color]="n.color">{{ n.icon }}</i>
            </div>
            <div class="text">
              <h5>{{ n.title }}</h5>
              <p>{{ n.desc }}</p>
              <div class="time">
                <i class="material-icons">access_time</i>{{ n.time }}
              </div>
            </div>
            <span class="dot"></span>
          </div>
        </div>

        <button class="view-all">
          View All Notifications <i class="material-icons">open_in_new</i>
        </button>
      </div>
    </div> -->

    <div class="profile-wrapper" (click)="toggleDropdown('profile', $event)">
      <div class="avatar">{{ initials }}</div>
      <i class="material-icons">keyboard_arrow_down</i>

      <div class="dropdown profile" *ngIf="showProfile">
        <div class="profile-header">
          <div class="avatar large">{{ initials }}</div>
          <div class="info">
            <h4>{{ user.first_name }} {{ user.last_name }}</h4>
            <p>{{ user.phone_email }}</p>
          </div>
        </div>

        <div class="menu">
         <div class="menu-item logout" (click)="goToProfilePage($event)">
            <div class="person-icon">
              <i class="material-icons ms-3">persons</i>
            </div>
            <div class="person content">
              <h5>My Profile</h5>
              <p>View and edit profile</p>
            </div>
          </div>
          <hr />

          <div class="menu-item logout" (click)="logout($event)">
            <div class="icon logout-icon">
              <i class="material-icons">logout</i>
            </div>
            <div class="content">
              <h5>Log out</h5>
              <p>Sign out of your account</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>